import { render, staticRenderFns } from "./PrintFabric.vue?vue&type=template&id=3fed312c"
import script from "./PrintFabric.vue?vue&type=script&lang=js"
export * from "./PrintFabric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports